import DiscoveryView from './views/DiscoveryView.vue'

export default [
  {
    path: '/discovery',
    name: 'discovery',
    component: DiscoveryView,
  },
]
